$(window).on("load",function(){
	$("body").removeClass("preload");
});
$(function(){

	var body = $('body');

	//SVGスプライト
	$.ajax({
		type: 'get',
		url: '/wp/wp-content/themes/bhc/assets/svg/icons.svg'//ここにパスを入れる（環境に合わせて変更）
	}).done(function(data) {
		var svg = $(data).find('svg');
		body.prepend(svg);
	});

	//ページ内スクロール
	$.smooziee();

	//サイドバー スクロールで固定
	if(($('body.single-column').length)){
		if (window.matchMedia( "(min-width: 768px)" ).matches) {
			jQuery(".pm_r").frix();
		}
	}

	//スクロールしたらクラスを付与
	$(window).scroll(function () {
		if ($(this).scrollTop() > 160) {
			body.addClass("scroll");
		} else {
			body.removeClass("scroll");
		}
	});

	//開閉用ボタンをクリックでクラスの切替え
	$('.header_menu_btn').on('click', function () {
		body.toggleClass('open');
		// bodyにopenがあれば
		if($(body).hasClass('open')){
			$('.header_menu_btn_text').html('閉じる');
		} else {
			$('.header_menu_btn_text').html('メニュー');
		}
		return false;
	});

	//メニュー名以外の部分をクリックで閉じる
	// $('.layer, .header_nav_box a').on('click', function () {
	// 	body.removeClass('open');
	// });

	//ヘッダードロップダウンメニュー
	$('.submenu_btn').on('click', function () {
		$(this).toggleClass('on');
		$(this).parents(".submenu").toggleClass('on');
		$(this).next(".submenu_wrap").toggleClass('on');
		$(".submenu_btn").not(this).removeClass("on");
		$(".submenu_btn").not(this).parents(".submenu").removeClass("on");
		$(".submenu_btn").not(this).next().removeClass("on");
		$(".submenu_btn").not(this).next().slideUp(300);
		$(this).next().slideToggle(300);

		if($(".list_service").hasClass('on')){
			$('.layer').addClass("on");
		} else {
			$('.layer').removeClass("on");
		}
		return false;
	});

	//商品スライダー
	const mySwiper_thumb = new Swiper('.product_swiper_thumb', {
		// slidesPerView: "auto",
		freeMode: true,
		watchSlidesVisibility: true,
		watchSlidesProgress: true,
		scrollbar: {
			el: '.swiper-scrollbar',
			draggable: true,
		},
		breakpoints: {
			320: {
				slidesPerView: 5.25,
				spaceBetween: 5,
			},
			// 768px以上の場合
			767: {
				slidesPerView: 5.7,
				spaceBetween: 10,
			},
		},
	});
	const mySwiper_main = new Swiper('.product_swiper', {
		thumbs: {
			swiper: mySwiper_thumb,
		},
	});

	//ピックアップ導入事例スライド
	var swiper = new Swiper(".case_swiper", {
		loop:true,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		breakpoints: {
			320: {
				slidesPerView: 1,
				spaceBetween: 21,
			},
			// 768px以上の場合
			767: {
				slidesPerView: 3,
				spaceBetween: 30,
			},
		},
	});

	//健康サポート薬局スライド
	var swiper = new Swiper(".pharmacy_swiper", {
		loop:true,
		centeredSlides: true,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		breakpoints: {
			320: {
				slidesPerView: 1.24,
				spaceBetween: 19,
			},
			// 768px以上の場合
			767: {
				// slidesPerView: 1.68,
				slidesPerView: 'auto',
				spaceBetween: 30,
			},
		},
	});

	//健康サポート薬局スライド 汎用
	const pharmacy_swiper_top = new Swiper('.pharmacy_swiper_top', {
		loop:true,
		slidesPerView: 'auto',
		centeredSlides: true,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		breakpoints: {
			320: {
				slidesPerView: 1.24,
				spaceBetween: 19,
			},
			// 768px以上の場合
			767: {
				slidesPerView: 'auto',
				spaceBetween: 30,
			},
		},
	});

	//固定CV フッター前で非表示
	$(window).on("scroll", function () {
		scrollHeight = $(document).height();
		scrollPosition = $(window).height() + $(window).scrollTop();
		footHeight = $(".footer").innerHeight();
		if (scrollHeight - scrollPosition <= footHeight) {
			$("body").addClass("fix_off");
		} else {
			$("body").removeClass("fix_off");
		}
	});

	//タブ切り替え
	$(".tab_btn").on("click",function(){
		var $th = $(this).index();
		$(this).parent().find(".tab_btn").removeClass("active");
		$(this).parent().next().find(".tab_panel").removeClass("active");
		$(this).addClass("active");
		$(this).parent().next().find(".tab_panel").eq($th).addClass("active");
	});

	//アコーディオン
	$(".acd_head").on("click", function() {
		$(this).toggleClass('open');
		$(this).next().slideToggle();
	});

	//アンカーナビゲーション制御（PCのみ）
	if(($('body.faq').length)){
		if (window.matchMedia( "(min-width: 768px)" ).matches) {
			var sectionArr = new Array(),
				elIndex = $('.faq_index_nav li a');
			for(i=0; i < elIndex.length; i++){
				var elLink = elIndex.eq(i).attr('href');
				sectionArr[i] = elLink;
			}
			$(window).on('load resize scroll', function(){
				var top = $(window).scrollTop() + ($(window).height() / 3);
				for(i=0; i < sectionArr.length; i++){
					var target = sectionArr[i],
						secTop = $(target).offset().top,
						secBottom = secTop + $(target).outerHeight(true);
					if(secTop <= top && secBottom >= top){
						elIndex.removeClass('active');
						elIndex.eq(i).addClass('active');
					}
				}
			});
		}
	}

	//モーダル
	$('.modal_open').each(function(){
		$(this).on('click',function(){
			var target = $(this).data('target');
			var modal = document.getElementById(target);
			$(modal).fadeIn();
			return false;
		});
	});
	$('.modal_bg').on('click',function(){
		$('.modal').fadeOut();
		return false;
	});
	$('.modal_close').on('click',function(){
		$('.modal').fadeOut();
		return false;
	});

});